import { useState, useEffect } from 'react';

function FloatingSidebar() {
  const [visible, setVisible] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <div
        className={`fixed right-4 md:right-6 bottom-24 z-40 flex flex-col gap-3 transition-all duration-300 ${
          visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
      >
        <button
          onClick={() => setChatOpen(!chatOpen)}
          className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-500 text-white hover:bg-primary-600 transition-all duration-200 cursor-pointer"
          title="在线咨询"
          aria-label="在线咨询"
        >
          <i className="ri-customer-service-2-line text-lg"></i>
        </button>

        <a
          href="tel:400-097-5066"
          className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-500 text-white hover:bg-accent-600 transition-all duration-200 cursor-pointer"
          title="一键拨号"
          aria-label="拨打电话"
        >
          <i className="ri-phone-line text-lg"></i>
        </a>

        <a
          href="/support/downloads"
          className="w-11 h-11 flex items-center justify-center rounded-full bg-foreground-800 text-white hover:bg-foreground-900 transition-all duration-200 cursor-pointer"
          title="产品白皮书下载"
          aria-label="资料下载"
        >
          <i className="ri-file-download-line text-lg"></i>
        </a>

        <button
          onClick={scrollToTop}
          className="w-11 h-11 flex items-center justify-center rounded-full bg-white border border-background-200 text-foreground-600 hover:text-primary-600 hover:border-primary-200 transition-all duration-200 cursor-pointer"
          title="回到顶部"
          aria-label="回到顶部"
        >
          <i className="ri-arrow-up-line text-lg"></i>
        </button>
      </div>

      {chatOpen && (
        <div className="fixed right-4 md:right-6 bottom-48 z-50 w-80 bg-white rounded-2xl border border-background-200 overflow-hidden"
          style={{ boxShadow: '0 8px 40px rgba(0,0,0,0.12)' }}
        >
          <div className="flex items-center justify-between px-5 py-4 bg-primary-500 text-white">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center">
                <i className="ri-wechat-line text-lg"></i>
              </div>
              <div>
                <div className="text-sm font-semibold">企业微信咨询</div>
                <div className="text-xs text-white/70">扫码添加专属顾问</div>
              </div>
            </div>
            <button
              onClick={() => setChatOpen(false)}
              className="w-7 h-7 flex items-center justify-center rounded-full hover:bg-white/20 transition-colors cursor-pointer"
            >
              <i className="ri-close-line"></i>
            </button>
          </div>
          <div className="p-5 flex flex-col items-center text-center">
            <div className="p-3 bg-white border border-background-200 rounded-2xl">
              <img
                src="/images/qrcode/wechatQR.png"
                alt="新译科技企业微信二维码"
                className="w-44 h-44 object-contain"
              />
            </div>
            <p className="mt-4 text-sm font-medium text-foreground-700">微信扫一扫，添加企业微信</p>
            <p className="mt-1 text-xs text-foreground-500">产品咨询 · 报价方案 · 样品申领 · 技术白皮书</p>
          </div>
        </div>
      )}
    </>
  );
}

export default FloatingSidebar;